import { render, staticRenderFns } from "./FormControlTypeCheckbox.vue?vue&type=template&id=606bd5e7"
import script from "./FormControlTypeCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlTypeCheckbox.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports